import axios from 'axios';
import moment from 'moment';
import {errorHandler} from "./libs/lib.js";


export default {
    upload(file,obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', file, file.name);
                for (const key in obj) {
                    fd.append(key, obj[key]);
                }
                const { data } = await axios.post(`transactionbank/upload`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },   
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','kodebank','typeDate','tanggal'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/transactionbank${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    }
}